import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import styles from './style.module.css';
import { percent, numberWithCommas, range } from '../../../../helpers';
import StepTwoForm from '../../components/forms/step-two';
import InfoBox from '../../../../common/components/info-box';
import FixedHeading from '../../../../common/components/fixed-heading';
import { formDetails as StepOneFormDetails } from '../../components/forms/step-one';
import { formDetails as StepTwoFormDetails } from '../../components/forms/step-two';

class StepTwo extends Component {
    render() {
        const {
            props: {
                income,
                expense
            }
        } = this;

        const tooltip = {
            title: 'Recommendation',
            content: <span>You're running a little hot on {(StepTwoFormDetails.title).toLowerCase()} expenses at <strong className={styles.redText}>{percent(expense, income)}%</strong> of your net income.</span>
        };

        let message = <span>Your net income is <strong>${numberWithCommas(income)}</strong>.</span>;

        if (percent(expense, income) > 0) {
            message = <span><span className={styles.hideMobile}>Currently </span><strong>{percent(expense, income)}%</strong> of your <strong>${numberWithCommas(income)}</strong> net income.</span>;
        }

        return (
            <div className={styles.page}>
                <p className={styles.topTitle}>Monthly Expenses</p>
                <h1 className={styles.mainTitle}>{StepTwoFormDetails.title}</h1>
                <p className={styles.text}>On average, {(StepTwoFormDetails.title).toLowerCase()} expenses for a household range between <strong>{range(`${StepTwoFormDetails.range.low}%`, `${StepTwoFormDetails.range.high}%`)}</strong> of your total net income.</p>
                <FixedHeading
                    title={`${StepTwoFormDetails.title} Expenses`}
                    content={message}
                />
                <StepTwoForm/>
                {
                    percent(expense, income) > StepTwoFormDetails.range.high &&
                    <InfoBox
                        title={tooltip.title}
                        content={tooltip.content}
                    />
                }
            </div>
        );
    }
}

const selector = formValueSelector(StepTwoFormDetails.formName);
const StepOneForm = formValueSelector(StepOneFormDetails.formName);

export default connect(state => {
    const expense = selector(state, StepTwoFormDetails.totalKey);
    const income = StepOneForm(state, StepOneFormDetails.totalKey);

    return {
        income: income ? income : 0,
        expense: expense ? expense : 0
    }
})(StepTwo);
